import { useEffect } from "react";
import { VStack, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";

import { useStores } from "../store/store_context";
import FiltersGrid from "../components/filters_grid";
import TableData from "../components/order_suppliers_page/table_data";

const OrderSuppliersPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllPaysOrgs();
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllBackups();
    pageStore.getAllOrderSupplierLegalEntities();
    pageStore.getAllOrderSupplierStages();
    pageStore.resetOrderSupplierFilters();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedView("manager-lite");
    pageStore.updateSelectedPeriod("");
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/orderSuppliers");
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="12px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid page="orderSuppliers" renderButtons={(buttons) => buttons} />

        <TableData
          data={pageStore?.data_order_suppliers}
          renderButtons={(buttons) => buttons}
        />
      </HStack>
    </VStack>
  );
});

export default OrderSuppliersPage;
